module.exports = __webpack_public_path__ + "static/media/ballons.e76e6472.png";